import { createSelector } from 'reselect';

import { RootState } from '..';
import { getActiveScheduleLineGroup } from './scheduleStationSelectors';

const getManuallyExpandedGridRows = (state: RootState) => state.panelData.expandedNavPanelRows;

export const getExpandedGridRows = createSelector(
  getManuallyExpandedGridRows,
  getActiveScheduleLineGroup,

  (expandedRows, activeScheduleLineGroup) => {
    const result = [...expandedRows];

    if (activeScheduleLineGroup) {
      result.push(activeScheduleLineGroup.guid);
    }

    return result;
  },
);
